import React from 'react'
import { useTranslation } from 'react-i18next';
import {  careers3Bg, careersIcon1, careersIcon2, careersIcon3, jobsArrow, jobsArrow2, rightArrow, subMenuContact2, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';


const newsItems = [
  {
    id: 1,
    imgSrc: subMenuHome,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '15.04.2025',
    region: "Bakı"
  },
  {
    id: 2,
    imgSrc: subMenuPartners,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '12.04.2025',
        region: "Bakı"
  },
  {
    id: 3,
    imgSrc: subMenuProjects,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '10.04.2025',
        region: "Bakı"
  },
  {
      id: 4,
      imgSrc: subMenuHome,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '15.04.2025',
          region: "Bakı"
    },
    {
      id: 5,
      imgSrc: subMenuPartners,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '12.04.2025',
          region: "Bakı"
    },
    {
      id: 6,
      imgSrc: subMenuProjects,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '10.04.2025',
          region: "Bakı"
    },
    {
      id: 7,
      imgSrc: subMenuHome,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '15.04.2025',
          region: "Bakı"
    },
    {
      id: 8,
      imgSrc: subMenuPartners,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '12.04.2025',
          region: "Bakı"
    },
    {
      id: 9,
      imgSrc: subMenuProjects,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '10.04.2025',
          region: "Bakı"
    },
];

const CareersJobItems = () => {


      const { t } = useTranslation();

  return (
    <div className='pt-[88px] md:pt-[104px] bg-[#FBFBFB]'>
        <div className='max-w-containerSm md:max-w-container mx-auto'>
          <p className='text-[#1C1C1C] font-medium text-[24px] md:text-[32px]'>Cari aktiv vakansiyalar</p>
       <div className='grid grid-cols-1 gap-5 mt-10'>
       {newsItems.map((item) => (
       <a className='group' key={item.id} href={`/careers-jobs/${item.id}`}>
       <div className='w-full rounded-[8px] border border-[#E5E5E5] p-7 text-[#1C1C1C] group-hover:bg-[#01A396] transition-colors duration-300'>
         <p className='text-[20px] md:text-[24px] font-medium group-hover:text-white'>{item.title}</p>
     
         <div className='flex justify-between items-center mt-5'>
           <div className='mt-4'>
     
             {/* Region section */}
             <div className='flex gap-2 items-center'>
               <img className='h-6 w-6 group-hover:hidden transition-opacity duration-300' src={subMenuContact2} alt="icon" />
               <img className='h-6 w-6 hidden group-hover:block transition-opacity duration-300' src={careersIcon2} alt="icon hover" />
               <p className='text-[16px] md:text-[18px] font-medium group-hover:text-white'>{item.region}</p>
             </div>
     
             {/* Date section */}
             <div className='flex gap-2 items-center mt-3'>
               <img className='h-6 w-6 group-hover:hidden transition-opacity duration-300' src={careersIcon1} alt="icon" />
               <img className='h-6 w-6 hidden group-hover:block transition-opacity duration-300' src={careersIcon3} alt="icon hover" />
               <p className='text-[16px] md:text-[18px] font-medium group-hover:text-white'>{item.date}</p>
             </div>
     
           </div>
     
           {/* Arrow icon */}
           <div>
           <img className='h-10 w-10 group-hover:hidden transition-opacity duration-300' src={jobsArrow} alt="icon" />
           <img className='h-10 w-10 hidden group-hover:block transition-opacity duration-300' src={jobsArrow2} alt="icon" />
           </div>
         </div>
       </div>
     </a>
     
            ))}
       </div>


    </div>
    </div>
  )
}

export default CareersJobItems